import { useEffect, useState } from 'react';

export interface UseWebSearchIndicatorReturn {
  /** "Navegando la web…" — el coach está haciendo una búsqueda web nativa. */
  isSearchingWeb: boolean;
}

/**
 * Indicador de búsqueda web nativa: el coach a veces busca en internet en medio
 * del turno. `orborix:web_search.started` prende el indicador; se apaga cuando
 * el coach empieza a streamear texto (la búsqueda ya terminó y está
 * respondiendo).
 *
 * Las FUENTES ya no viajan por acá: se anclan a la burbuja del bot en el cliente
 * de voz (`VoiceMessage.sources`) y se renderizan bajo el mensaje que las generó
 * (chip → sheet), no como un listado suelto en el hilo.
 */
export function useWebSearchIndicator(assistantText: string): UseWebSearchIndicatorReturn {
  const [isSearchingWeb, setIsSearchingWeb] = useState(false);

  useEffect(() => {
    const onStarted = (): void => setIsSearchingWeb(true);
    window.addEventListener('orborix:web_search.started', onStarted);
    return () => {
      window.removeEventListener('orborix:web_search.started', onStarted);
    };
  }, []);

  useEffect(() => {
    if (assistantText.length > 0 && isSearchingWeb) setIsSearchingWeb(false);
  }, [assistantText, isSearchingWeb]);

  return { isSearchingWeb };
}
